import React, { useState, useEffect, useRef } from 'react';
import { FormControl, Dropdown, InputGroup } from 'react-bootstrap';

const SearchableDropdown = ({
  options,
  onSelect,
  onInputChnge,
  placeholder = "Search...",
  defaultSelected = null,
  selectedValue,
  disabled,
  showAll
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredOptions, setFilteredOptions] = useState(options);
  const [selectedItem, setSelectedItem] = useState(defaultSelected);
  const [showDropdown, setShowDropdown] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    if (showAll) return
    if (options) {
      setFilteredOptions(
        options.filter(option =>
          option?.label?.toLowerCase().includes(searchTerm.toLowerCase())
        )
      );
    }
  }, [searchTerm, options]);

  useEffect(() => {
    // Only update searchTerm from selectedValue if not currently editing
    if (!isEditing && selectedValue) {
      const selected = options.find(option => option.label == selectedValue);

      setSearchTerm(selected ? selected.label : '');
    }
  }, [selectedValue, options, isEditing]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
        setIsEditing(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (defaultSelected) {
      const selected = options.find(opt =>
        opt.value === defaultSelected || opt.label === defaultSelected
      );
      if (selected) {
        setSelectedItem(selected);
        setSearchTerm(selected.label);
      }
    }
  }, [defaultSelected, options]);

  const handleSelect = (option) => {
    setSelectedItem(option);
    setSearchTerm(option.label);
    onSelect(option);
    setShowDropdown(false);
    setIsEditing(false);
  }

  const handleInputChange = (e) => {
    setSearchTerm(e.target.value);
    setShowDropdown(true);
    setIsEditing(true);
    if (onInputChnge) {
      onInputChnge(e.target.value)
    }
    if (!e.target.value) {
      setSelectedItem(null);
      onSelect(null);
    }
  };

  const handleInputClick = () => {
    setShowDropdown(true);
    setIsEditing(true);
  };
  console.log("selectedItem", defaultSelected)

  return (
    <div ref={dropdownRef} style={{ position: 'relative' }}>
      <Dropdown show={showDropdown} style={{ width: '100%' }}>
        <InputGroup>
          <FormControl
            disabled={disabled ? true : false}
            type="text"
            placeholder={placeholder}
            value={searchTerm}
            onChange={handleInputChange}
            onClick={handleInputClick}
            aria-autocomplete="list"
            aria-expanded={showDropdown}
            className='form-select-value shadow-none'
          />
        </InputGroup>
        <Dropdown.Menu
          style={{
            width: '100%',
            maxHeight: '300px',
            overflowY: 'auto',
            marginTop: '2px'
          }}
          className='py-0 dropdown-equipment-wp'
        >
          {filteredOptions?.length > 0 ? (
            filteredOptions.map((option) => (
              <Dropdown.Item
                key={option.value}
                onClick={() => handleSelect(option)}
                active={selectedItem && selectedItem.value === option.value}
                className='items-lable-value'
              >
                {option.label}
              </Dropdown.Item>
            ))
          ) : (
            <Dropdown.Item disabled className='items-lable-value'>No options found</Dropdown.Item>
          )}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default SearchableDropdown;
